import { useReactiveSelectQuery } from "@/models/hooks/useReactiveSelectQuery.ts";
import { fetchFeedPermissions } from "@/models/repositories";

export type InvalidFeedPermissionsReturn = "Loading" | "NoRightsToViewContentModal" | "Feed";
export const invalidFeedPermissions = ({
  workspaceMembershipId,
  feedId,
  bootstrapComplete,
}: {
  workspaceMembershipId: string | undefined;
  feedId: string;
  bootstrapComplete: boolean;
}): InvalidFeedPermissionsReturn => {
  const feedPermissionsResult = useReactiveSelectQuery(
    fetchFeedPermissions,
    [
      {
        workspaceMembershipId,
        feedId,
      },
    ],
    "queryTransformers.fetchFeedPermissions",
  );

  if (!bootstrapComplete || !workspaceMembershipId || feedPermissionsResult == null) {
    return "Loading";
  }

  const noAccess = feedPermissionsResult.filter((perm) => perm.enabled === false && perm.name === "read").length > 0;
  const filtered = feedPermissionsResult.filter((perm) => perm.enabled);

  if (noAccess || filtered.length === 0) {
    return "NoRightsToViewContentModal";
  }
  return "Feed";
};
